"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateIcon = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const DuplicateIcon = ({ fill = "#E6E6E6", size = 16, title = "Duplicate" }) => (react_1.default.createElement(Base_1.Base, { smooth: true, fill: fill, size: size, title: title },
    react_1.default.createElement("path", { d: "M12,0L7,0 7,3.2 11,7.2 11,12 16,12 16,4 12,0zM11,5L11,1 15,5 11,5zM5,4L0,4 0,16 9,16 9,8 5,4zM4,9L4,5 8,9 4,9z" })));
exports.DuplicateIcon = DuplicateIcon;
//# sourceMappingURL=Duplicate.js.map